module.exports = __webpack_public_path__ + "static/bubble_big-c4875c3f667bf67b7fa2bc6efbf1bd70.png";